import { render, staticRenderFns } from "./KAMDashboard.vue?vue&type=template&id=640ef25c&scoped=true"
import script from "./KAMDashboard.vue?vue&type=script&lang=ts"
export * from "./KAMDashboard.vue?vue&type=script&lang=ts"
import style0 from "./KAMDashboard.vue?vue&type=style&index=0&id=640ef25c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640ef25c",
  null
  
)

export default component.exports